import React, { useEffect, useState } from "react";
import { ScalableImage, Typography, useDevice } from "design_system/src";

export interface FinancingStepCardData {
  step: string;
  title: string;
  description: React.ReactNode;
  imageUrl: string;
  imageDesktopUrl: string;
  imageAlt: string;
}

const FinancingStepCard: React.FC<FinancingStepCardData> = (
  { title, description, step, imageUrl, imageDesktopUrl, imageAlt }
) => {
  const { isMobile: isDeviceMobile, isTablet: isDeviceTablet, isLoading } = useDevice();
  const [isMobile, setIsMobile] = useState<boolean>();
  const [isTablet, setIsTablet] = useState<boolean>();
  const [imgUrl, setImgUrl] = useState<string>();

  useEffect(() => {
    if (!isLoading) {
      setIsMobile(isDeviceMobile);
      setIsTablet(isDeviceTablet);
    }

  }, [isDeviceMobile, isDeviceTablet, isLoading]);

  useEffect(() => {
    if (isMobile !== undefined) {
      setImgUrl(isMobile ? imageUrl : imageDesktopUrl);
    }

  }, [isMobile]);

  return (
    <div className="w_100_per h_100_per display_flex flex_col_mobile flex_justify_center flex_justify_evenly_mobile flex_justify_between_desktop">
      <div className="w_100_per w_30_per_desktop m_b_md_mobile display_flex flex_col flex_justify_center">
        <Typography
          weight="600"
          scale="heading3"
          scaleMobile="heading4"
          className="text_primary_300 m_none m_b_lg"
          component="h3"
        >{step}:<br/>{title}
        </Typography>
        {description}
      </div>
      <div className="display_flex w_100_per w_60_per_desktop">
        {imgUrl && (
          <ScalableImage
            src={imgUrl}
            mobileWidth={80}
            desktopWidth={50}
            alt={imageAlt}
            style={{
              objectFit: "contain",
              width: "100%",
              height: "100%",
              maxWidth: isMobile ? "500px" : "unset",
              margin: isMobile ? "auto" : "unset",
            }}
          />
        )}
      </div>
    </div>
  );
};

export default FinancingStepCard;